import React from "react";
import { FormControlStyles } from "../../components/ui/FormControlStyles";
import { Background } from "../../features/kquant/components/Background";
import { Header } from "../../features/kquant/components/Header";
import { AmbientBackground } from "./AmbientBackground";
import { HeroSection } from "./HeroSection";
import { StrategiesSection } from "./StrategiesSection";

export default function MyQuantFlowsPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#05050f] text-white">
      <FormControlStyles />
      <Background />
      <AmbientBackground />

      <div className="relative mx-auto max-w-[1280px] px-8">
        <Header />

        <main className="pb-16">
          <HeroSection />
          <StrategiesSection />
        </main>
      </div>
    </div>
  );
}
